import React from 'react';

const MobileLoadingSkeleton = ({ variant = 'card', count = 1 }) => {
  const shimmerClass = 'animate-pulse bg-gray-200 dark:bg-gray-700 rounded';

  const CardSkeleton = () => (
    <div className="p-4">
      <div className={`${shimmerClass} w-full h-40 mb-3`} />
      <div className={`${shimmerClass} w-3/4 h-4 mb-2`} />
      <div className={`${shimmerClass} w-1/2 h-3 mb-2`} />
      <div className="flex gap-2 mt-3">
        <div className={`${shimmerClass} w-20 h-6`} />
        <div className={`${shimmerClass} w-16 h-6`} />
      </div>
    </div>
  );

  const ListSkeleton = () => (
    <div className="flex gap-3 p-4">
      <div className={`${shimmerClass} w-20 h-20 flex-shrink-0`} />
      <div className="flex-1">
        <div className={`${shimmerClass} w-3/4 h-4 mb-2`} />
        <div className={`${shimmerClass} w-1/2 h-3 mb-2`} />
        <div className={`${shimmerClass} w-20 h-5`} />
      </div>
    </div>
  );

  const LineSkeleton = () => (
    <div className="px-4 py-2">
      <div className={`${shimmerClass} w-full h-4 mb-2`} />
      <div className={`${shimmerClass} w-2/3 h-3`} />
    </div>
  );

  const HeroSkeleton = () => (
    <div className="px-4">
      <div className={`${shimmerClass} w-full h-48 mb-3`} />
      <div className={`${shimmerClass} w-3/4 h-5 mb-2`} />
      <div className={`${shimmerClass} w-1/2 h-3 mb-3`} />
      <div className="flex gap-2">
        <div className={`${shimmerClass} w-24 h-9`} />
        <div className={`${shimmerClass} w-24 h-9`} />
      </div>
    </div>
  );

  const skeletons = {
    card: CardSkeleton,
    list: ListSkeleton,
    line: LineSkeleton,
    hero: HeroSkeleton,
  };

  const Skeleton = skeletons[variant] || CardSkeleton;

  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <Skeleton key={i} />
      ))}
    </>
  );
};

export default MobileLoadingSkeleton;
